import { render, staticRenderFns } from "./pageLoadingV2.vue?vue&type=template&id=f62f7fb6&scoped=true"
import script from "./pageLoadingV2.vue?vue&type=script&lang=js"
export * from "./pageLoadingV2.vue?vue&type=script&lang=js"
import style0 from "./pageLoadingV2.vue?vue&type=style&index=0&id=f62f7fb6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62f7fb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/1/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f62f7fb6')) {
      api.createRecord('f62f7fb6', component.options)
    } else {
      api.reload('f62f7fb6', component.options)
    }
    module.hot.accept("./pageLoadingV2.vue?vue&type=template&id=f62f7fb6&scoped=true", function () {
      api.rerender('f62f7fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/static/loading/pageLoadingV2.vue"
export default component.exports